import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

export const ProductionChainStepWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "production-chain-step-wrapper",
})`
  padding: 8px 0;
  margin-inline-start: 8px;
  border-bottom: 1px solid ${blueGreyMui._100};

  &:last-child {
    border-bottom: none;
  }

  .collapse-header__title {
    font-weight: 500;
  }

  .production-chain-step-inner {
    margin-top: 10px;
  }
`;
